module.exports = __webpack_public_path__ + "static/media/linkedin-in.88280442.svg";